import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {validateValue} from 'app/utilities/validation/validator';
import {validationRules} from 'app/utilities/validation/validationVariables';
import ProviderManager from '../../../provider/providerManager';
import {formatDeliveryTimeSlots} from 'app/utilities/dateUtils';
import {
  dwhAccountNotFoundError,
  dwhAssociatedWithAnotherOrgError,
  dwhCauseSelectionGeneralError,
  dwhCreateDeliveryNotificationError,
  dwhGeneralErrorOnValidate,
  dwhIDFCauseSelectionGeneralError,
  dwhIDFCreateDeliveryNotificationError,
} from './reports/dwhReports';
import {getOnboardingSubs} from 'app/Components/Page/SelfCarePage/SelfCareAsyncThunk.js';

import {hideAppLoader, showAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';
import {TAB_ENUM} from 'app/Components/Page/SelfCarePage/Constant';

export const getGeneralData = createAsyncThunk('IMEIDeviceRepairBlock/getGeneralData', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('IMEIDeviceRepairGeneralData', []);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      serverError: true,
      serverErrorDescription: error,
    };
  }
});
export const validateAccountToIMEIService = createAsyncThunk(
  'IMEIDeviceRepairBlock/validateAccountToIMEIService',
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showAppLoader());
      const result = await ProviderManager.getProviderData('validateAccountToIMEIService', [
        data.orgId,
        data.startPoint,
        data.selectedNumber,
        data.selectedIMEI,
        data.isPrivate,
        data.isFromPrivateSelfCare,
      ]);
      thunkAPI.dispatch(hideAppLoader());
      return result.Body;
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      return {
        serverError: true,
        serverErrorDescription: error,
      };
    }
  },
);

export const submitSelectedEMEIConfirmation = createAsyncThunk(
  'IMEIDeviceRepairBlock/submitSelectedEMEIConfirmation',
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showAppLoader());
      const result = await ProviderManager.getProviderData('submitSelectedEMEIConfirmation', [
        data.orgId,
        data.startPoint,
        data.selectedNumber,
        data.selectedIMEI,
        data.isPrivate,
        data.isFromPrivateSelfCare,
      ]);
      thunkAPI.dispatch(hideAppLoader());
      return result.Body;
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      return {
        serverError: true,
        serverErrorDescription: error,
      };
    }
  },
);

export const isLockedValidation = createAsyncThunk('IMEIDeviceRepairBlock/isLockedValidation', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('isLockedValidationImeiDeviceRepair', [data]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      serverError: true,
      serverErrorDescription: error,
    };
  }
});

export const getPickUpDeliveryTimeSlots = createAsyncThunk('IMEIDeviceRepairBlock/getPickUpDeliveryTimeSlots', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const resp = await ProviderManager.getProviderData('getPickUpDeliveryTimeSlots', [
      data.city,
      data.street,
      data.homeNum,
      data.dispatchType,
      data.refOrder,
    ]);
    return {
      city: data.city,
      street: data.street,
      homeNum: data.homeNum,
      dispatchType: data.dispatchType,
      apartment: data.apartmentNum,
      result: resp.Body,
    };
  } catch (error) {
    return {
      serverError: true,
      serverErrorDescription: error,
    };
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const createNotification = createAsyncThunk('IMEIDeviceRepairBlock/createNotification', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('createNotificationImeiRepairDevice', [
      data.selectedNumber,
      data.selectedIMEI,
      data.causeList,
      data.lockCode,
      data.alternatePhone,
      data.clearContent,
      data.notificationType,
      data.isPrivate,
      data.isFromPrivateSelfCare,
    ]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      serverError: true,
      serverErrorDescription: error,
    };
  }
});
export const createPickUpNotification = createAsyncThunk('IMEIDeviceRepairBlock/createPickUpNotification', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('createPickupDeliveryNotification', [
      data.selectedNumber,
      data.street,
      data.city,
      data.houseNum,
      data.apartmentNum,
      data.contactPersonName,
      data.contactPersonLastName,
      data.contactPersonPhone,
      data.notes,
      data.refOrder,
      data.pickUpRefOrder,
      data.dispLidRsn,
      data.dlvDate,
      data.shipCond,
      data.notificationType,
      data.pickLocation,
      data.lockCode,
      data.alternatePhone,
      data.clearContent,
      data.isPrivate,
      data.isFromPrivateSelfCare,
    ]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      serverError: true,
      serverErrorDescription: error,
    };
  }
});
export const createDeliveryNotification = createAsyncThunk('IMEIDeviceRepairBlock/createDeliveryNotification', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('createPickupDeliveryNotification', [
      data.selectedNumber,
      data.street,
      data.city,
      data.houseNum,
      data.apartmentNum,
      data.contactPersonName,
      data.contactPersonLastName,
      data.contactPersonPhone,
      data.notes,
      data.refOrder,
      data.pickUpRefOrder,
      data.dispLidRsn,
      data.dlvDate,
      data.shipCond,
      data.notificationType,
      data.pickLocation,
      data.lockCode,
      data.alternatePhone,
      data.clearContent,
      data.isPrivate,
      data.isFromPrivateSelfCare,
      data.selectedIMEI,
    ]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      serverError: true,
      serverErrorDescription: error,
    };
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const getSubscriberList = createAsyncThunk('cellcomAbroad/getCustomerCellularList', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    /* const OnboardingData = await ProviderManager.getProviderData('OnboardingData', {});
    const subscribersByProduct = OnboardingData?.Body?.subscribersByProduct[TAB_ENUM.Cellular];
    const subscribers = subscribersByProduct.map((product) => product.productSubscriberNo);*/
    const subscribers = await thunkAPI.dispatch(getOnboardingSubs());
    return {data: subscribers.payload, error: false};
  } catch (error) {
    return {error: true};
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const popUpEnum = {
  MEMBER_OF_DIFFERENT_ORG: 'MemberOfDifferentOrg',
  IS_LOCKED: 'IsLocked',
  DELIVERIES_FOUND: 'deliveriesFound',
  IMEI_HELP: 'imeiHelp',
  WARR_ISSUR_IND: 'WarrInsurInd',
  GENERAL_ERRROR: 'GENERAL_ERROR',
};

export const stepEnum = {
  VALIDATION: 'validation',
  SELECT_IMEI: 'selectImei',
  SELECT_SUBSCRIBER: 'selectSubscriber',
  CAUSE_SELECTION: 'cause_selection',
  UPDATE_DELIVERIES: 'update_deliveries',
  PICK_UP_ADDRESS: 'pick_up_address',
  DELIVERY_ADDRESS: 'delivery_address',
  COMPLETED: 'completed',
  ERROR: 'error',
  IS_LOCKED_FAILED: 'IsLockedFailed',
  OTP: 'OTP',
};

export const startPointEnum = {
  PHONE: 'PHONE',
  IMEI: 'IMEI',
};

export const formName = {
  form: 'form',
  selectCauseForm: 'selectCauseForm',
  pickUpAddressForm: 'pickUpAddressForm',
  deliveryAddressForm: 'deliveryAddressForm',
};

export const errorDescriptionEnum = {
  GENERAL_ERROR: 'general_error',
  MEMBER_OF_DIFFERENT_ORG: 'MemberOfDifferentOrg',
  ORG_ID_NOT_FOUND: 'OrgIdNotFound',
  ACCOUNT_NOT_FOUND: 'AccountNotFound',
  IS_LOCKED: 'IsLocked',
  MEMBER_OF_DIFFERENT_ORG_NOT_ALLOWED_TO_CONTACT_PERSON: 'MemberOfDifferentOrgNotAllowedToContactPerson',
  ERROR_ON_VALIDATION: 'ErrorOnValidation',
  NO_EQUIPMENT_IS_ATTACHED: 'NoEquipmentIsAttached',
  WARR_ISSUR_IND: 'WarrInsurInd',
  IS_LOCKED_FAILED: 'IsLockedFailed',
};

export const notificationType = {
  CREATE_NOTIFICATION: 'CREATE_NOTIFICATION',
  PICKUP: 'PICKUP',
  SEND: 'SEND',
};

export const dispatchType = {
  RCV: 'RCV',
  SND: 'SND',
};

function getLoginType(authenticationState) {
  if (authenticationState?.loginData?.isFullAuthenticated) {
    return 'isFullAuthenticated';
  } else if (authenticationState?.loginData?.isOtpAuthenticated) {
    return 'isOtpAuthenticated';
  } else if (authenticationState?.loginData?.isOtpExtendedAuthenticated) {
    return 'isOtpExtendedAuthenticated';
  } else {
    return null;
  }
}

function handleServerError(state, dwhData) {
  state.currentStep = stepEnum.ERROR;
  state.errorDescription = errorDescriptionEnum.GENERAL_ERROR;
  dwhGeneralErrorOnValidate({...dwhData, step: 'validateAccountToIMEIService'});
}

function handleStartPoint(state, action) {
  if (state.startPoint === startPointEnum.IMEI) {
    state.selectedIMEI = state.form.imei;

    state.selectedPhoneNumber = action.payload.selectedAccountPhoneNumber;

  } else {
    state.selectedIMEI = action.payload.selectedIMEI;
    state.selectedPhoneNumber = state.selectedPhoneNumber === '' ? state.form.phone : state.selectedPhoneNumber;
  }
  state.pickUpAddressForm.pickUpContactPhone = state.selectedPhoneNumber;
}

function handleError(state, action, dwhData) {
  switch (action.payload.errorDescription) {
    case errorDescriptionEnum.MEMBER_OF_DIFFERENT_ORG:
      state.selectedAccountOrgId = action.payload.selectedAccountOrgId;
      state.selectedAccountOrgName = action.payload.selectedAccountOrgName;
      dwhAssociatedWithAnotherOrgError(dwhData);
      handleErrorPopUp(state, action.payload.errorDescription);
      return state;
    case errorDescriptionEnum.IS_LOCKED:
    case errorDescriptionEnum.WARR_ISSUR_IND:
      if (state.currentStep === null || state.currentStep === stepEnum.OTP) {
        state.currentStep = stepEnum.ERROR;
      }
      handleErrorPopUp(state, action.payload.errorDescription);
      break;
    case errorDescriptionEnum.ACCOUNT_NOT_FOUND:
      state.showErrorMessage = true;
      state.errorType = action.payload.errorDescription;
      dwhAccountNotFoundError(dwhData);
      break;
    default:
      state.errorDescription = action.payload.errorDescription;
      state.currentStep = stepEnum.ERROR;
      state.showErrorMessage = true;
  }
}

function handleErrorPopUp(state, errorDescription) {
  //get the popUpEnum
  state.popUp = popUpEnum[Object.keys(popUpEnum).find((key) => popUpEnum[key] === errorDescription)];
}

function handleSuccess(state, action) {
  state.IMEIList = action.payload.imeiList;
  state.validFindMyPhone = true;
  state.selectedAccountOrgName = action.payload.selectedAccountOrgName;

  if (state.startPoint === startPointEnum.IMEI) {
    state.showConfirmPhoneMsg = true;
  }

  state.pickUpAddressForm.pickUpContactName = action.payload.selectedCustomerName;
  state.pickUpAddressForm.pickUpContactLastName = action.payload.selectedCustomerLastName;
  state.deliveries = action.payload.openDeliveries;

  if (state.deliveries?.length >= 1 && [stepEnum.VALIDATION, stepEnum.SELECT_IMEI, stepEnum.OTP].includes(state.currentStep)) {
    state.popUp = popUpEnum.DELIVERIES_FOUND;
  }
}

const handleEMEIServerError = (state, action) => {
  state.currentStep = stepEnum.ERROR;
  state.errorDescription = errorDescriptionEnum.GENERAL_ERROR;
  const step = 'submitSelectedEMEIConfirmation';
  dwhGeneralErrorOnValidate({
    subscriber: state.dwhData.subscriber,
    selectedHetPay: state.dwhData.selectedHetPay,
    customerName: state.dwhData.customerName,
    dwhParam: state.startPoint === startPointEnum.IMEI ? state.form.imei : state.form.phone,
    step,
  });
};

const handleEMEIPayloadError = (state, action) => {
  const {errorDescription} = action.payload;

  switch (errorDescription) {
    case errorDescriptionEnum.IS_LOCKED:
    case errorDescriptionEnum.WARR_ISSUR_IND:
      handleErrorPopUp(state, errorDescription);
      break;

    case errorDescriptionEnum.ACCOUNT_NOT_FOUND:
      state.errorDescription = errorDescription;
      state.currentStep = stepEnum.ERROR;
      dwhAccountNotFoundError({
        subscriber: state.dwhData.subscriber,
        selectedHetPay: state.dwhData.selectedHetPay,
        customerName: state.dwhData.customerName,
        dwhParam: state.startPoint === startPointEnum.IMEI ? state.form.imei : state.form.phone,
      });
      break;

    case errorDescriptionEnum.MEMBER_OF_DIFFERENT_ORG:
      state.selectedAccountOrgId = action.payload.selectedAccountOrgId;
      state.selectedAccountOrgName = action.payload.selectedAccountOrgName;
      handleErrorPopUp(state, errorDescription);
      break;

    default:
      state.errorDescription = errorDescription;
      state.currentStep = stepEnum.ERROR;
  }
};

const handleEMEIPayloadSuccess = (state, action) => {
  state.deliveries = action.payload.openDeliveries;
  const isDeliveriesEmpty = !action.payload.openDeliveries || action.payload.openDeliveries.length === 0;
  const isCurrentStepInList = [stepEnum.VALIDATION, stepEnum.SELECT_IMEI, stepEnum.OTP, stepEnum.SELECT_SUBSCRIBER].includes(
    state.currentStep,
  );

  if (!action.payload.isAllowedToCauseSelection) {
    state.currentStep = stepEnum.ERROR;
    return state;
  } else if (state.currentStep !== stepEnum.UPDATE_DELIVERIES && isDeliveriesEmpty) {
    state.currentStep = stepEnum.CAUSE_SELECTION;
    return state;
  } else if (!isDeliveriesEmpty && isCurrentStepInList) {
    state.popUp = popUpEnum.DELIVERIES_FOUND;
    return state;
  }

  state.pickUpAddressForm.pickUpContactName = action.payload.selectedCustomerName;
  state.pickUpAddressForm.pickUpContactLastName = action.payload.selectedCustomerLastName;

  if (state.currentStep !== stepEnum.UPDATE_DELIVERIES && state.deliveries == null) {
    state.currentStep = stepEnum.CAUSE_SELECTION;
    return state;
  }
};

const causeInitialItem = {
  selectedCauseType: '',
  selectedCauseSubType: '',
  errors: {},
};

const selectCauseInitialForm = {
  causeList: [causeInitialItem],
  securityCode: '',
  lockCodeExists: false,
  clearContent: false,
  alternatePhone: null,
  rules: {
    selectedCauseType: {
      required: {value: true, error: 'יש להזין סוג תקלה'},
    },
    selectedCauseSubType: {
      required: {value: true, error: 'יש להזין סוג תקלה'},
    },
    securityCode: {
      required: {value: true, error: 'יש להזין קוד'},
    },
  },
  errors: {},
};
const pickUpAddressInitialForm = {
  city: '',
  street: '',
  homeNum: '',
  pickUpContactName: '',
  pickUpContactLastName: '',
  pickUpContactPhone: '',
  pickUpNotes: '',
  pickUpTimeSlot: null,
  rules: {
    pickUpContactPhone: validationRules.phone,
    pickUpContactName: {
      required: {value: true, error: 'יש להזין שם'},
    },
    pickUpContactLastName: {
      required: {value: true, error: 'יש להזין שם משפחה'},
    },
    pickUpTimeSlot: {
      required: {value: true, error: 'יש לבחור מועד'},
    },
  },
  errors: {},
};

const deliveryAddressInitialForm = {
  city: '',
  street: '',
  homeNum: '',
  deliveryContactName: '',
  deliveryContactLastName: '',
  deliveryContactPhone: '',
  deliveryNotes: '',
  deliveryTimeSlot: null,
  rules: {
    deliveryContactName: {
      required: {value: true, error: 'יש להזין שם'},
    },
    deliveryContactLastName: {
      required: {value: true, error: 'יש להזין שם משפחה'},
    },
    deliveryContactPhone: validationRules.phone,
    deliveryTimeSlot: {
      required: {value: true, error: 'יש לבחור מועד'},
    },
  },
  errors: {},
};

const initialState = {
  startPoint: startPointEnum.PHONE,
  causeSelectionList: null,
  isShowLoader: false,
  popUp: null,
  currentStep: null,
  goToNextStep: false,
  errorDescription: '',
  selectedPhoneNumber: '',
  showConfirmPhoneMsg: false,
  showErrorMessage: false,
  errorType: '',
  selectedAccountOrgId: '',
  selectedAccountOrgName: '',
  IMEIList: [],
  selectedIMEI: '',
  createNotificationTicketNumber: '',
  pickUpTicketNumber: '',
  deliveryTicketNumber: '',
  validFindMyPhone: false,
  pickUpTimeSlots: null,
  deliveryTimeSlots: null,
  deliveries: null,
  form: {
    phone: '',
    imei: '',
    rules: {
      imei: validationRules.imei,
      phone: validationRules.phone,
    },
    errors: {},
  },
  selectCauseForm: selectCauseInitialForm,
  pickUpAddressForm: pickUpAddressInitialForm,
  deliveryAddressForm: deliveryAddressInitialForm,
  createNotificationUsedData: {},
  dwhData: {},
  isPrivate: false,
  numberCallCenter: '',
  deliveryPrice: 0,
  isInitialized: false,
  causeList: null,
  subscribers: null,
  confirmedPhoneNumber: false,
};

const IMEIDeviceRepairSlice = createSlice({
  name: 'IMEIDeviceRepair',
  initialState: initialState,
  reducers: {
    resetState: () => initialState,
    changeHandler: {
      reducer(state, action) {
        state[action.payload.form][action.payload.name] = action.payload.value;
        state[action.payload.form].errors[action.payload.name] = action.payload.error;
        state[action.payload.form].valid = action.payload.valid;
      },
      prepare(payload) {
        const value = payload.value;
        const name = payload.name;
        const error = validateValue(payload.rule, payload.name, payload.value);
        const form = payload.form;
        const valid = !error;
        return {
          payload: {
            name,
            value,
            error,
            valid,
            form,
          },
        };
      },
    },
    changeCauseHandler: {
      reducer(state, action) {
        if (action.payload.name == 'selectedCauseType') {
          state.selectCauseForm.causeList[action.payload.index].selectedCauseType = action.payload.value;
        } else {
          state.selectCauseForm.causeList[action.payload.index].selectedCauseSubType = action.payload.value;
        }
        state.selectCauseForm.causeList[action.payload.index].errors[action.payload.name] = action.payload.error;
      },
      prepare(payload) {
        const value = payload.value;
        const name = payload.name;
        const error = validateValue(payload.rule, payload.name, payload.value);
        const index = payload.index;

        return {
          payload: {
            name,
            value,
            error,
            index,
          },
        };
      },
    },
    saveDWHParams: (state, action) => {
      state.dwhData.selectedHetPay = action.payload.selectedHetPay;
      state.dwhData.customerName = action.payload.customerName || state.dwhData.customerName;
      state.dwhData.subscriber = action.payload.subscriber || state.dwhData.subscriber;
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    disableGoToNextStep: (state, action) => {
      state.goToNextStep = false;
    },
    hideErrorMessage: (state, action) => {
      state.showErrorMessage = false;
    },
    setPopup: (state, action) => {
      state.popUp = action.payload;
    },
    setStartPoint: (state, action) => {
      state.startPoint = action.payload;
      if (action.payload === startPointEnum.IMEI) {
        state.form.phone = '';
        state.selectedPhoneNumber = '';
      } else {
        state.form.imei = '';
      }
      state.form.errors = {};
      state.showConfirmPhoneMsg = false;
      return state;
    },
    confirmPhoneConnectedToIMEI: (state, action) => {
      state.showConfirmPhoneMsg = false;
    },
    setSelectedIMEI: (state, action) => {
      state.errorDescription = '';
      state.selectedIMEI = action.payload;
    },
    addCauseSelection: (state, action) => {
      let currentCausesList = state.selectCauseForm.causeList;
      currentCausesList.push(causeInitialItem);
      state.selectCauseForm.causeList = currentCausesList;
      return state;
    },
    removeCauseSelection: (state, action) => {
      let currentCausesList = state.selectCauseForm.causeList;
      currentCausesList.splice(action.payload, 1);
      state.selectCauseForm.causeList = currentCausesList;
      return state;
    },
    saveCauseSelectionStepData: (state, action) => {
      state.createNotificationUsedData = state.selectCauseForm;
    },
    setPickUpNotes: (state, action) => {
      state.pickUpAddressForm.pickUpNotes = action.payload;
    },
    setDeliveryNotes: (state, action) => {
      state.deliveryAddressForm.deliveryNotes = action.payload;
    },
    setLockCodeExists: (state, action) => {
      state.selectCauseForm.errors.securityCode = '';
      state.selectCauseForm.lockCodeExists = action.payload;
      if (!action.payload) {
        state.selectCauseForm.securityCode = '';
      }
    },
    clearPickUpSlots: (state, action) => {
      state.pickUpTimeSlots = null;
      state.pickUpAddressForm.pickUpTimeSlot = null;
    },
    clearDeliverySlots: (state, action) => {
      state.deliveryTimeSlots = null;
      state.deliveryAddressForm.deliveryTimeSlot = null;
    },
    saveSelectedPickUpSlot: (state, action) => {
      state.pickUpAddressForm.pickUpTimeSlot = action.payload;
      state.pickUpAddressForm.errors.pickUpTimeSlot = '';
    },
    saveSelectedDeliverySlot: (state, action) => {
      state.deliveryAddressForm.deliveryTimeSlot = action.payload;
      state.deliveryAddressForm.errors.deliveryTimeSlot = '';
    },
    closeModal: (state, action) => {
      state.popUp = null;
    },
    saveToHistory: (state, action) => {
      return state;
    },
    clearHistory: (state, action) => {
      return state;
    },
    setIsPrivate: (state, action) => {
      state.isPrivate = action.payload;
    },
    setNumberCallCenter: (state, action) => {
      state.numberCallCenter = action.payload;
    },
    setSelectedPhoneNumber: (state, action) => {
      state.selectedPhoneNumber = action.payload;
    },
    setAutoFillValues: (state, action) => {
      if (action.payload) {
        state.deliveryAddressForm.city = state.pickUpAddressForm.city;
        state.deliveryAddressForm.street = state.pickUpAddressForm.street;
        state.deliveryAddressForm.homeNum = state.pickUpAddressForm.homeNum;
        state.deliveryAddressForm.apartmentNum = state.pickUpAddressForm.apartmentNum;
      } else {
        state.deliveryAddressForm.city = '';
        state.deliveryAddressForm.street = '';
        state.deliveryAddressForm.homeNum = '';
        state.deliveryAddressForm.apartmentNum = '';
      }
    },
    setIsInitialized: (state, action) => {
      state.isInitialized = action.payload;
    },
    setCauseList: (state, action) => {
    state.causeList = action.payload
      },
    confirmPhoneNumber: (state, action) => {
      state.confirmPhoneNumber = true;
    }
  },
  extraReducers: {
    [getGeneralData.pending]: (state, action) => {
      state.isShowLoader = true;
    },
    [getGeneralData.fulfilled]: (state, action) => {
      state.isShowLoader = false;
      state.causeSelectionList = action.payload.causeTypeList;
    },
    [validateAccountToIMEIService.pending]: (state, action) => {
      state.isShowLoader = true;
      state.showErrorMessage = false;
    },
    [validateAccountToIMEIService.fulfilled]: (state, action) => {
      state.isShowLoader = false;
      const {subscriber, selectedHetPay, customerName} = state.dwhData;
      const dwhParam = state.startPoint === startPointEnum.IMEI ? state.form.imei : state.form.phone;

      if (action.payload.serverError) {
        handleServerError(state, {subscriber, selectedHetPay, customerName, dwhParam});
        return state;
      }

      handleStartPoint(state, action);

      if (action.meta.arg.orgId === '' && action.payload.selectedAccountOrgId) {
        state.selectedAccountOrgId = action.payload.selectedAccountOrgId;
        state.selectedAccountOrgName = action.payload.selectedAccountOrgName;
        state.popUp = popUpEnum.MEMBER_OF_DIFFERENT_ORG;
        return state;
      }

      if (action.payload.error || (action.meta.arg.orgId === '' && action.payload.selectedAccountOrgId)) {
        handleError(state, action, {subscriber, selectedHetPay, customerName, dwhParam});
        return state;
      }

      handleSuccess(state, action);
      return state;
    },
    [submitSelectedEMEIConfirmation.pending]: (state, action) => {
      state.isShowLoader = true;
      state.errorDescription = '';
    },
    [submitSelectedEMEIConfirmation.fulfilled]: (state, action) => {
      state.isShowLoader = false;
      if (action.payload.serverError) {
        handleEMEIServerError(state, action);
      } else if (action.payload.error) {
        handleEMEIPayloadError(state, action);
      } else {
        handleEMEIPayloadSuccess(state, action);
      }
      return state;
    },
    [isLockedValidation.pending]: (state, action) => {
      state.isShowLoader = true;
    },
    [isLockedValidation.fulfilled]: (state, action) => {
      state.isShowLoader = false;
      if (action.payload.serverError) {
        state.currentStep = stepEnum.ERROR;
        state.errorDescription = errorDescriptionEnum.GENERAL_ERROR;
        return state;
      }
      if (action.payload.statusCode == '0') {
        if (!action.payload.boolean) {
          state.validFindMyPhone = true;
          if (state.currentStep == stepEnum.VALIDATION && state.startPoint == startPointEnum.IMEI) {
            state.showConfirmPhoneMsg = true;
            return state;
          }
          state.currentStep = stepEnum.CAUSE_SELECTION;
        }
      }
      return state;
    },
    [getPickUpDeliveryTimeSlots.pending]: (state, action) => {
      if (state.currentStep == stepEnum.PICK_UP_ADDRESS) {
        state.pickUpAddressForm.errors = {};
      } else {
        state.deliveryAddressForm.errors = {};
      }
    },
    [getPickUpDeliveryTimeSlots.fulfilled]: (state, action) => {
      if (action.payload.serverError) {
        if (state.currentStep == stepEnum.PICK_UP_ADDRESS) {
          state.pickUpAddressForm.errors.pickUpTimeSlot = 'אופס, משהו השתבש! נסו שוב במועד מאוחר יותר ';
        } else {
          state.deliveryAddressForm.errors.deliveryTimeSlot = 'אופס, משהו השתבש! נסו שוב במועד מאוחר יותר ';
        }
        return state;
      }
      if (action.payload.message && action.payload.message != undefined) {
        if (state.currentStep == stepEnum.PICK_UP_ADDRESS) {
          state.pickUpAddressForm.errors.pickUpTimeSlot = action.payload.message;
        } else {
          state.deliveryAddressForm.errors.deliveryTimeSlot = action.payload.message;
        }

        return state;
      }

      if (action.payload.errorCode && action.payload.errorCode == 1200) {
        if (state.currentStep == stepEnum.PICK_UP_ADDRESS) {
          state.pickUpAddressForm.errors.pickUpTimeSlot = 'לא נמצאו מועדי שליחות לאיסוף פנויים';
        } else {
          state.deliveryAddressForm.errors.deliveryTimeSlot = 'לא נמצאו מועדי שליחות למסירה פנויים';
        }
        return state;
      }

      try {
        if (state.currentStep == stepEnum.PICK_UP_ADDRESS) {
          state.pickUpTimeSlots = formatDeliveryTimeSlots(action.payload.result);
          state.pickUpAddressForm.city = action.payload.city;
          state.pickUpAddressForm.street = action.payload.street;
          state.pickUpAddressForm.homeNum = action.payload.homeNum;
          state.pickUpAddressForm.apartmentNum = action.payload.apartment;
        } else {
          state.deliveryTimeSlots = formatDeliveryTimeSlots(action.payload.result);
          state.deliveryAddressForm.city = action.payload.city;
          state.deliveryAddressForm.street = action.payload.street;
          state.deliveryAddressForm.homeNum = action.payload.homeNum;
          state.deliveryAddressForm.apartmentNum = action.payload.apartment;
        }
      } catch (error) {
        if (state.currentStep === stepEnum.PICK_UP_ADDRESS) {
          state.pickUpAddressForm.errors.pickUpTimeSlot = action.payload.message;
        } else {
          state.deliveryAddressForm.errors.deliveryTimeSlot = action.payload.message;
        }

        return state;
      }
    },
    [createNotification.pending]: (state, action) => {
      state.isShowLoader = true;
      state.createNotificationTicketNumber = '';
      state.pickUpTicketNumber = '';
      state.deliveryTicketNumber = '';
    },
    [createNotification.fulfilled]: (state, action) => {
      state.isShowLoader = false;

      if (action.payload.serverError) {
        state.currentStep = stepEnum.ERROR;
        state.errorDescription = errorDescriptionEnum.GENERAL_ERROR;
        const subscriber = state.dwhData.subscriber;
        const selectedHetPay = state.dwhData.selectedHetPay;
        const customerName = state.dwhData.customerName;
        const phone = state.selectedPhoneNumber;
        const param2 = state.selectCauseForm.causeList[0].selectedCauseType;
        const param3 = state.selectCauseForm.causeList[0].selectedCauseSubType;
        if (state.isPrivate) {
          dwhIDFCauseSelectionGeneralError({customerName, subscriber, param2, param3});
        } else {
          dwhCauseSelectionGeneralError({
            selectedHetPay,
            customerName,
            subscriber,
            phone,
            param2,
            param3,
          });
        }
        return state;
      }
      if (action.payload.error || action.payload.statusCode != '00' || !action.payload.param) {
        state.currentStep = stepEnum.ERROR;
        return state;
      } else {
        state.createNotificationTicketNumber = action.payload.param;
        state.deliveryPrice = parseFloat(action.payload.statusDescription);
        state.goToNextStep = true;
      }
    },
    [createPickUpNotification.pending]: (state, action) => {
      state.isShowLoader = true;
      state.pickUpTicketNumber = '';
    },
    [createPickUpNotification.fulfilled]: (state, action) => {
      state.isShowLoader = false;
      if (action.payload.serverError) {
        state.currentStep = stepEnum.ERROR;
        state.errorDescription = errorDescriptionEnum.GENERAL_ERROR;
        return state;
      }
      if (action.payload.error || action.payload.statusCode != '00' || !action.payload.param) {
        state.currentStep = stepEnum.ERROR;
        state.pickUpTicketNumber = '';
        return state;
      } else {
        state.pickUpTicketNumber = action.payload.param;
        state.deliveryAddressForm.deliveryContactName = state.pickUpAddressForm.pickUpContactName;
        state.deliveryAddressForm.deliveryContactLastName = state.pickUpAddressForm.pickUpContactLastName;
        state.deliveryAddressForm.deliveryContactPhone = state.pickUpAddressForm.pickUpContactPhone;
        state.goToNextStep = true;
      }
    },
    [createDeliveryNotification.pending]: (state, action) => {
      state.isShowLoader = true;
    },
    [createDeliveryNotification.fulfilled]: (state, action) => {
      state.isShowLoader = false;
      if (action.payload.serverError) {
        const subscriber = state.dwhData.subscriber;
        const selectedHetPay = state.dwhData.selectedHetPay;
        const customerName = state.dwhData.customerName;
        const phone = state.selectedPhoneNumber;
        const param2 = state.selectCauseForm.causeList[0].selectedCauseType;
        const param3 = state.selectCauseForm.causeList[0].selectedCauseSubType;
        if (props.isPrivate) {
          dwhIDFCreateDeliveryNotificationError({customerName, subscriber, param2, param3});
        } else {
          dwhCreateDeliveryNotificationError({
            selectedHetPay,
            customerName,
            subscriber,
            phone,
            param2,
            param3,
          });
        }
        state.currentStep = stepEnum.ERROR;
        state.errorDescription = errorDescriptionEnum.GENERAL_ERROR;
        return state;
      }
      if (action.payload.error || action.payload.statusCode != '00' || !action.payload.param) {
        state.popUp = popUpEnum.GENERAL_ERRROR;
        state.currentStep = stepEnum.ERROR;
        return state;
      } else {
        state.deliveryTicketNumber = action.payload.param;
        state.currentStep = stepEnum.COMPLETED;
      }
    },
    [getSubscriberList.fulfilled]: (state, action) => {
      if (action.payload.error) {
        state.currentStep = stepEnum.ERROR;
        state.errorDescription = errorDescriptionEnum.GENERAL_ERROR;
        return state;
      }
      state.subscribers = action.payload.data;
    },
  },
});

export const {
  changeHandler,
  changeCauseHandler,
  clearIsValid,
  validateHandler,
  setCurrentStep,
  disableGoToNextStep,
  setPopup,
  setStartPoint,
  closeModal,
  setSelectedIMEI,
  setLockCodeExists,
  resetState,
  setPickUpNotes,
  setDeliveryNotes,
  addCauseSelection,
  removeCauseSelection,
  saveCauseSelectionStepData,
  confirmPhoneConnectedToIMEI,
  clearPickUpSlots,
  clearDeliverySlots,
  saveSelectedPickUpSlot,
  saveSelectedDeliverySlot,
  saveToHistory,
  clearHistory,
  hideErrorMessage,
  saveDWHParams,
  setIsPrivate,
  setNumberCallCenter,
  setSelectedPhoneNumber,
  setAutoFillValues,
  setCauseList,
  setIsInitialized,
  confirmPhoneNumber
} = IMEIDeviceRepairSlice.actions;

export default IMEIDeviceRepairSlice.reducer;
